class exports.GeoJSON_Layer extends Handler
    constructor: () ->
        super()
        @possibleAreaKeys = ['area', 'acres']
        @areaPropertyName = 'area'
        @squareMetersToHectares = 0.0001
        @squareMetersToAcres = 0.000247105
        @layoutSelector = null
        @reposition_map = false
        @defaultOpacity = 70

        @useSlider      = false
        @fetchUrl       = null


    beforeProcess: (response, geojson) ->
        undefined

    afterProcess: (response, geojson) ->
        undefined

    onSlider: (ev, ui) =>
        @setOpacity(ui.value)

    applyLayerStyling: (geojson) =>
        @layer = L.geoJson @flattenMultiPolygons(geojson), {
            # set the style for each feature of the collection
            style: (ft) =>
                def = {
                    fillColor: "#{ft.properties.fillColor ? "#00FF00"}",
                    color: "#000000",
                    opacity: 0.75
                    fillOpacity: @_fillOpacity ? 0.3
                    weight: 1
                }

                return $.extend def, ft.mapProperties

            # Configure popup behavior
            onEachFeature: (ft, layer) =>
                @addAreaProperty(ft)
                @makeInfoWindow(ft, layer)
        }

    init: () ->
        self = this

        # Set up basic slider events, if necessary
        if @useSlider
            @initSlider()
            if @slider
                @slider.on 'slide', (e, ui) =>
                    @setOpacity(ui.value)

        @loadReq = $.post @fetchUrl,
            @loadLayoutPostOptions,
            (response) =>
                geojson = @getGeometry response

                # allow processing to be redirected
                result = @beforeProcess(response, geojson)

                # if we redirected processing then don't bother finishing
                if result isnt 'skip'
                    @applyLayerStyling(geojson)
                    @showLayer()
                    @setOpacity @defaultOpacity
                    @afterProcess(response, geojson, @layer)

    getGeometry: (response) =>
        if response.status?.type is 'error'
            App.addPopup('MissingFileDialog')
            @destroy()
            return

        return $.parseJSON(response)


    makeInfoWindow: (ft, layer) ->
        noshows = ['bin', 'fillColor', 'binVal', 'BuPerAc', 'average_population', 'min', 'max', 'class', 'average']

        if ft.properties
            info = "
                <table class='table table-condensed margin-top-22'>
            "
            for k, v of ft.properties
                # prevent styling properties from showing up
                if not (k in noshows) and @hackit(k, ft.properties)
                    info += "<tr><td><strong>#{k}</strong></td><td>#{v}</td></tr>"

            info += "</table>"

            layer.bindPopup info

    hackit: (str, properties) ->
        if str is 'Population' and _.has(properties, 'Seed Population')
            return false

        return true


    setOpacity: (v) ->
        fill = (v / 100).toFixed(2)
        line = ((v + 100) / 200).toFixed(2)

        if @layer?
            @layer.eachLayer (layer) ->
                layer.setStyle {
                    fillOpacity: fill
                    opacity: line
                }

        @_opacity = v
        @_fillOpacity = fill
        @_lineOpacity = line


    hideLayer: () ->
        App.map.removeLayer @layer

        if @useSlider and @slider
            @slider.slider 'disable'

    showLayer: () ->
        App.map.addLayer @layer

        if @reposition_map
            App.map.fitBounds @layer.getBounds()

        if @useSlider and @slider
            @slider.slider 'enable'


    refresh: () ->
        @cleanUp()
        super()


    destroy: () ->
        @cleanUp()

        super()


    cleanUp: () ->
        if @useSlider and @slider
            @slider.off 'slide'
            @slider.slider 'disable'

        if @loadReq?
            @loadReq.abort()

        if @layer?
            App.map.removeLayer @layer

        # call the callback if one has been set
        @callback?()

    flattenMultiPolygons: (geojson) ->
        flatFeatures = []

        # exit early if there are no multipolygons because if there is at least one multipolygon we have to recalculate area for all features
        # technically non multipolygon features wouldn't need area recalculated if the label didn't matter, but we will want the label to match
        # for all polygons
        if not (feature for feature in geojson.features when feature.geometry.type.toLowerCase() is 'multipolygon').length
            return geojson

        for feature in geojson.features
            # first remove any area related properties
            for key, value of feature.properties
                for possibleKey in @possibleAreaKeys when _.includes(key.toLowerCase(), possibleKey)
                    delete(feature.properties[key])

            if feature.geometry.type.toLowerCase() is 'multipolygon'
                # flatten the feature
                flattened = turf.flatten(feature)

                # copy over the map specific properties
                for flattenedFeature, index in flattened.features
                    # This changes the feature to be a copy of the original without being by reference
                    # it basically makes it so that all of the flattened features can have their own individual properties
                    # where updating one doesn't automatically update the other, which is what we want
                    flattened.features[index] = JSON.parse(JSON.stringify(flattenedFeature))
                    # copy any map properties that were set on the original
                    flattened.features[index].mapProperties = feature.mapProperties if feature.mapProperties

                flatFeatures = flatFeatures.concat(flattened.features)
            else
                flatFeatures.push feature

        return turf.featureCollection(flatFeatures)

    addAreaProperty: (feature) ->
        # add an area property to any features that do not already have one
        for name, value of feature.properties when _.includes(name.toLowerCase(), @areaPropertyName.toLowerCase())
            # exit the function if there is already an area property
            return

        areaInSquareMeters = turf.area(feature)

        if App.is_metric
            feature.properties['Area (ha)'] = _.round(areaInSquareMeters * @squareMetersToHectares, 1)
        else
            feature.properties['Area (ac)'] = _.round(areaInSquareMeters * @squareMetersToAcres, 1)
